<template lang="pug">
.invoice-orders-styled-panel
  //- Header con título y contador
  .d-flex.align-items-center.justify-content-between.tw-mb-3.tw-pb-2.tw-border-b.tw-border-gray-200
    .d-flex.align-items-center.tw-gap-2
      .tw-w-10.tw-h-10.tw-rounded-lg.tw-bg-blue-100.tw-flex.tw-items-center.tw-justify-center
        i.fa-solid.fa-clipboard-list.tw-text-blue-600.tw-text-lg
      div
        span.tw-font-semibold.tw-text-gray-700 Orders in this Invoice
        span.tw-bg-blue-100.tw-text-blue-700.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-font-medium.tw-ml-2
          | {{ items.length }}
  
  //- Leyenda de columnas
  .tw-flex.tw-items-center.tw-gap-4.tw-mb-3.tw-text-xs(v-if='!emptyItems')
    span.tw-text-gray-500 Column Groups:
    .d-flex.align-items-center.tw-gap-1
      span.tw-w-3.tw-h-3.tw-rounded.tw-bg-gray-200
      span.tw-text-gray-600 Identification
    .d-flex.align-items-center.tw-gap-1
      span.tw-w-3.tw-h-3.tw-rounded.tw-bg-amber-200
      span.tw-text-gray-600 Timeline
    .d-flex.align-items-center.tw-gap-1
      span.tw-w-3.tw-h-3.tw-rounded.tw-bg-green-200
      span.tw-text-gray-600 Pricing
  
  //- Tabla mejorada
  table(v-if='!emptyItems' class="table table-hover invoice-orders-styled-table")
    thead.tw-bg-gray-50
      tr
        //- Grupo: Identificación
        th.tw-text-center.tw-bg-gray-100(style="border-left: 2px solid #e5e7eb;")
          .d-flex.align-items-center.tw-gap-1.justify-content-center
            i.fa-solid.fa-hashtag.tw-text-gray-400.tw-text-xs
            span ID
        th.tw-text-center.tw-bg-gray-100
          span Job #
        th.tw-text-center.tw-bg-gray-100(style="border-right: 2px solid #e5e7eb;")
          span Kanela ID
        //- Status
        th.tw-text-center
          .d-flex.align-items-center.tw-gap-1.justify-content-center
            i.fa-solid.fa-flag.tw-text-gray-400.tw-text-xs
            span {{$I18n.t('vue.invoice_orders_table_panel.table_header_status')}}
        th.tw-text-center
          span {{$I18n.t('vue.invoice_orders_table_panel.table_header_frequency')}}
        //- Grupo: Pricing
        th.tw-text-center.tw-bg-green-50(style="border-left: 2px solid #bbf7d0;")
          .d-flex.align-items-center.tw-gap-1.justify-content-center
            i.fa-solid.fa-dollar-sign.tw-text-green-500.tw-text-xs
            span {{$I18n.t('vue.invoice_orders_table_panel.table_header_price')}}
        //- Grupo: Timeline
        th.tw-text-center.tw-bg-amber-50(style="border-left: 2px solid #fde68a;")
          .d-flex.align-items-center.tw-gap-1.justify-content-center
            i.fa-solid.fa-calendar-day.tw-text-amber-500.tw-text-xs
            span Due
        th.tw-text-center.tw-bg-amber-50
          span Scheduled
        th.tw-text-center.tw-bg-amber-50(style="border-right: 2px solid #fde68a;")
          .d-flex.align-items-center.tw-gap-1.justify-content-center
            i.fa-solid.fa-check-circle.tw-text-amber-500.tw-text-xs
            span Completed
        //- Restaurant info
        th.tw-text-left
          .d-flex.align-items-center.tw-gap-1
            i.fa-solid.fa-store.tw-text-gray-400.tw-text-xs
            span {{$I18n.t('vue.invoice_orders_table_panel.table_header_restaurant')}}
        th.tw-text-center
          span Target
        th.tw-text-center.tw-w-16
    tbody
      tr(v-for="item in items" :key="item.id" :class="getRowClass(item)")
        //- Error row
        template(v-if="item.error")
          td.tw-text-center.tw-bg-gray-50
            span.tw-font-mono.tw-text-sm {{item.id}}
          td(colspan="10" class="tw-text-center")
            span.tw-inline-flex.tw-items-center.tw-px-3.tw-py-1.tw-bg-red-100.tw-text-red-700.tw-rounded.tw-text-sm
              i.fa-solid.fa-exclamation-triangle.tw-mr-2
              | Error: {{item.error}}
          td
        //- Normal row
        template(v-else)
          //- Identification group
          td.tw-text-center.tw-bg-gray-50.tw-bg-opacity-50
            a.tw-font-mono.tw-text-blue-600.tw-text-sm.tw-font-medium(:href="order_path(item.id)" target="_blank")
              | {{item.id}}
          td.tw-text-center.tw-bg-gray-50.tw-bg-opacity-50
            span.tw-text-gray-600.tw-text-sm {{item.job_number || '—'}}
          td.tw-text-center.tw-bg-gray-50.tw-bg-opacity-50
            span.tw-text-gray-600.tw-text-sm {{item.id_kanela || '—'}}
          //- Status
          td.tw-text-center
            span.tw-inline-flex.tw-items-center.tw-px-2.tw-py-1.tw-rounded.tw-text-xs.tw-font-medium(:class="getStatusClass(item)")
              | {{item.state && item.state.name ? $I18n.t('vue.states.'+item.state.name.toLowerCase()) : 'N/A'}}
          td.tw-text-center
            span.tw-text-gray-600.tw-text-sm {{item.frequency_month=="" || item.frequency_month==null ? (item.frequency || '—') : $I18n.t('vue.invoice_orders_table_panel.months')+": "+item.frequency_month}}
          //- Price
          td.tw-text-center.tw-bg-green-50.tw-bg-opacity-50
            span.tw-font-semibold.tw-text-green-700 ${{item.price ? (item.price*100/100).toFixed(2) : '0.00'}}
          //- Timeline group
          td.tw-text-center.tw-bg-amber-50.tw-bg-opacity-50
            span.tw-text-gray-600.tw-text-sm {{item.locale_due_at || '—'}}
          td.tw-text-center.tw-bg-amber-50.tw-bg-opacity-50
            span.tw-text-gray-600.tw-text-sm {{item.locale_schedule_for || '—'}}
          td.tw-text-center.tw-bg-amber-50.tw-bg-opacity-50
            span.tw-text-gray-600.tw-text-sm(v-if="item.locale_completed_at") {{item.locale_completed_at}}
            span.tw-text-gray-400.tw-text-sm(v-else) —
          //- Restaurant
          td.tw-text-left
            .d-flex.align-items-center.tw-gap-2(v-if="item.subsidary && item.subsidary.name")
              .tw-w-6.tw-h-6.tw-rounded.tw-bg-purple-100.tw-flex.tw-items-center.tw-justify-center.tw-flex-shrink-0
                i.fa-solid.fa-utensils.tw-text-purple-500.tw-text-xs
              span.tw-text-gray-700.tw-text-sm.tw-truncate(style="max-width: 150px;" :title="item.subsidary.name") {{item.subsidary.name}}
            span.tw-text-gray-400.tw-text-sm(v-else) —
          td.tw-text-center
            span.tw-text-xs.tw-text-gray-500 {{item.subsidary && item.subsidary.invoice_target ? $I18n.t('vue.invoice_target.'+(item.subsidary.invoice_target+"").toLowerCase()) : '—'}}
          td.tw-text-center
            a.tw-text-blue-600.hover_tw-text-blue-800(:href="order_path(item.id)" target="_blank" :title="$I18n.t('vue.invoice_orders_table_panel.view_order')")
              i.fa-solid.fa-external-link
  
  //- Total
  .tw-flex.justify-content-end.tw-mt-3(v-if='!emptyItems')
    .tw-bg-green-50.tw-border.tw-border-green-200.tw-rounded-lg.tw-px-4.tw-py-2
      .d-flex.align-items-center.tw-gap-3
        span.tw-text-gray-600.tw-text-sm {{$I18n.t('vue.invoice_orders_table_panel.total_orders')}}
        span.tw-font-bold.tw-text-green-700.tw-text-lg {{calcularTotal()}}

  //- Empty state
  .tw-text-center.tw-py-8(v-if='emptyItems')
    .tw-w-16.tw-h-16.tw-bg-gray-100.tw-rounded-full.tw-flex.tw-items-center.tw-justify-center.tw-mx-auto.tw-mb-3
      i.fa-solid.fa-clipboard-list.tw-text-gray-400.tw-text-2xl
    p.tw-text-gray-500.tw-mb-0 {{$I18n.t('vue.invoice_orders_table_panel.empty_items')}}

</template>
<script>
import CoreComponents from "../core";
import RemoveOrderFromInvoice from "./remove-order-from-invoice-modal.vue"
import StickyTableMixin from '../../mixins/sticky_table_mixin.js';
const { BackendRoutes } = require("app/services");
export default {
  mixins: [StickyTableMixin],
  components:{
    "app-icon-link": CoreComponents.AppIconLink,
    "remove-order-from-invoice-modal": RemoveOrderFromInvoice,
  },
  props:{
    dataItems: String,
  },
  data: function(){
    return {
      record:{
      },
      items: JSON.parse(this.dataItems),
      labels:{
      }
    }
  },
  computed:{
    emptyItems: function(){
      return this.items.length === 0;
    }
  },
  methods:{
    getRowClass: function(item) {
      if (item.error) return '';
      if (item.state && item.state.name === 'CANCELED') {
        return 'tw-bg-red-50 tw-bg-opacity-50 tw-line-through';
      }
      if (item.state && item.state.name === 'COMPLETED') {
        return 'tw-bg-green-50 tw-bg-opacity-30';
      }
      return '';
    },
    getStatusClass: function(item) {
      if (!item.state || !item.state.name) return 'tw-bg-gray-100 tw-text-gray-700';
      const statusMap = {
        'COMPLETED': 'tw-bg-green-100 tw-text-green-700',
        'CANCELED': 'tw-bg-red-100 tw-text-red-700',
        'REGISTERED': 'tw-bg-blue-100 tw-text-blue-700',
        'SCHEDULED': 'tw-bg-purple-100 tw-text-purple-700',
        'IN_PROGRESS': 'tw-bg-amber-100 tw-text-amber-700',
      };
      return statusMap[item.state.name] || 'tw-bg-gray-100 tw-text-gray-700';
    },
    retrieveLinks:function(){
      
    },
    order_path: function (order_id) {
      return BackendRoutes.order_path(order_id);
    },
    calcularTotal:function(){
      // Usamos reduce para iterar sobre el array y sumar los precios
      let total = this.items.reduce((total, item) => {
        // Verificamos si el estado del elemento es diferente de "CANCELED"
        if (item.state.name !== "CANCELED") {
          // Si es diferente, sumamos su precio al total
          return total + parseFloat(item.price.replace("$", "").replace(",", "").replace(" ", ""));
        } else {
          // Si es "CANCELED", simplemente retornamos el total sin modificarlo
          return total;
        }
      }, 0); // Inicializamos el total en 0
      return total.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }
  }
}
</script>

<style scoped>
.invoice-orders-styled-panel {
  padding: 0.5rem;
}

.invoice-orders-styled-table {
  font-size: 0.8rem;
}

.invoice-orders-styled-table thead th {
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.5rem 0.5rem;
  font-weight: 600;
  color: #4b5563;
  font-size: 0.75rem;
}

.invoice-orders-styled-table tbody td {
  vertical-align: middle;
  padding: 0.4rem 0.5rem;
}

.tw-bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}

.tw-bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}

.tw-line-through {
  text-decoration: line-through;
}

.tw-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hover_tw-text-blue-800:hover {
  color: #1e40af;
}
</style>
